'use client';
import { styled } from '@linaria/react';

import { HEADER_HEIGHT, SUPERHEADER_HEIGHT } from '@/constants';
import { useGlobalUIState } from '@/components/GlobalUIProvider';

function Blocker({
  style = {},
  ...delegated
}: React.HTMLAttributes<HTMLDivElement>) {
  const { superheader } = useGlobalUIState();

  const blockerHeight = superheader
    ? HEADER_HEIGHT + SUPERHEADER_HEIGHT
    : HEADER_HEIGHT;

  return (
    <BaseBlocker
      style={{ ...style, height: blockerHeight + 'rem' }}
      {...delegated}
    />
  );
}

const BaseBlocker = styled.div`
  position: sticky;
  top: 0;
`;

export default Blocker;
